<template>
	<div class="qualityenterprise">
		<leftnav class="fl" :mkcode="mkcode" itemcode="A-JWSSQY" docutitle="外资招商"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">外资招商</span>
						<div class="fl search-box ot-search-box" style="margin-left: 260px;">
							<span class="searchtype">{{title}}</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> 
					</div> 
				<div class="opport-screen-list1"> 
							<dl class="opport-screen bdbe" v-if="userdata.zsdn_version != 1">
								<dt class="fl">企业库</dt>
								<dd class="fl"> 
									<span v-for="(item,index) in enterinarr" :key="index" @click="routerself('/enterpriseList?type='+item.type+'&Pt='+item.curindex)" class="a-screen">{{item.name}}</span>
									<span @click="routerself('/totalEnterprises')" class="a-screen">全部内资企业库</span>
									<span class="blueline"></span>
									<span class="a-screen current">境外上市企业库</span>
									<span @click="routerself('/forcapEnterprise')" class="a-screen ">外资企业库</span>  
									<!-- <el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i	class="el-icon-question listeltootipicon" ></i>
										<div slot="content" class="list_tips">
											<p>上市公司：A股上市的公司 </p>
											<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p>
											<p>创新企业：被专业投资机构认可并成功融资的企业</p>
											<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p> 
											<p>外资企业：外商投资的企业</p>
											<p>境外上市企业：在境外证券交易所公开上市的企业</p>
										</div>
									</el-tooltip> -->
										<video-teaching :type="1"></video-teaching>
								</dd>
								<dd class="fl" v-if="curWebsite.type == 5 || curWebsite.type == 10">
									<span :key="index" v-for="(item,index) in tz_enterinarr" @click="routerself('/markingEnterpriseist?type='+item.type);" class="a-screen">{{item.name}}</span> 
									<span class="blueline"></span>
									<span class="a-screen current" >境外上市企业</span> 
									<span @click="routerself('/forcapEnterprise')" class="a-screen" >外资企业</span>  
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
											class="el-icon-question listeltootipicon"></i>
										<div slot="content" class="list_tips">
											<p>上市公司：A股上市的公司 </p>
											<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p> 
											<p>外资企业：外商投资的企业</p>
											<p>境外上市企业：在境外证券交易所公开上市的企业</p>
										</div>
									</el-tooltip>
								</dd>
							</dl> 
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl" v-if="curWebsite.type != 5">
									<span class="a-screen" @click="routerself('/forcapEnterprise')">外资企业库(按注册地)</span>
									<span class="a-screen" @click="routerself('/foreignInvestment')">外资企业库(按来源国)</span>
									<span class="a-screen current">全球上市企业库</span>
									<span class="a-screen" @click="routerself('/overseasInstitutions')">海外机构名录</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">所在大洲</dt>
								<dd class="fl">
									<span :class="continentId == 0?'current a-screen':'a-screen'" @click="chooseOpport({country:[],id:0})">全部</span>
									<span v-for="(item,index) in paramList.continent" :key="'continent'+index" v-show="item.country.length>0"	@click="chooseOpport(item)"	:class="item.id == continentId?'a-screen current' : 'a-screen'">{{item.name}} </span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="countryData.length>0">
								<dt class="fl">所属地区</dt>
								<dd class="fl">
									<span :class="countryId == 0?'current a-screen':'a-screen'" @click="getIsFree('contry',0)">全部</span>
									<span v-for="(item,index) in countryData" :key="'country'+index" @click="getIsFree('contry',item.id)"	:class="item.id == countryId?'a-screen current' : 'a-screen'">{{item.name}} </span>
								</dd>
							</dl>  
							<dl class="opport-screen bdbe">
								<dt class="fl">所属行业</dt>
								<dd class="fl">
									<span :class="industryId == 0?'current a-screen':'a-screen'" @click="getIsFree('industry')">全部</span>
									<!-- <em>({{item.num}})</em> -->
									<span v-for="(item,index) in industryNumData" :key="'industry'+index" @click="getIsFree('industry',item.id)"	:class="item.id == industryId?'a-screen current' : 'a-screen'">{{item.name}}<em class="num">({{item.num}})</em></span>
								</dd>
							</dl>
							<!-- <dl class="opport-screen bdbe">
								<dt class="fl">上市板块</dt>
								<dd class="fl">
									<span :class="plateId == 0?'current a-screen':'a-screen'"@click="plateId = 0;getForeignEnList()">全部</span>
									<span v-for="(item,index) in paramList.plate"	@click="plateId=item.id;getForeignEnList()"	:class="item.id == plateId?'a-screen current' : 'a-screen'">{{item.name}}</span>
								</dd>
							</dl> --> 
						</div>
				</div> 
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpriseList.length>0">
							<span>导出数据</span></div>
					</div>
					<!-- 多维度分数筛选  --> 
				<!-- 	<ul class="dimensionScreen oh w95mg" v-show="enterpriseList.length>0"> 
						<li :class="orderField == list.type ?'fl current ':'fl '"   v-for="(list,index) in dimensionList" @click="tablesort(list.type);" v-show="list.name!='融资时间'||searchtype == 2"> 
							<span 	:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span> 
							<span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span> 
						</li> 
					</ul> --> 
					<!-- v-show="enterpriseList.length!=0" -->
					<div class="enterprise_list_box" > 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>名称</th>
								<th>代码</th>
								<th>交易平台</th> 
								<th>板块</th>
								<th>行业</th>
								<th>员工人数</th>
								<th>编辑</th>
							</tr> 
							 <tr v-for="(list,index) in enterpriseList" :key="index">
							 	<!-- <td>{{(page-1)*pageSize+index+1}}</td> -->
									<td class="title" @click="routerlinkid('/enterprisesF',list.id)">{{list.title}}</td>
							 	<td>{{list.stockCode}}</td>
							 	<td>{{list.exchangeTrans}}</td>
							 	<td>{{list.plate}}</td>
							 	<td>{{list.industry}}</td>
							 	<td>{{list.employee}}</td>
									<td class="collectfont1"><span  @click="listToggleCollect(list,'acoc')">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							 </tr>
						</table> 
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出列表弹框 -->
		<div class="enlistexportPop" v-show="exportpop">
			<div class="enlistexportPop_box">
				<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
				<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
				<span class="closebtn" @click="exportpop=false"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'ForeignEnterprises',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "境外上市企业库",
				searchPlaceholder:'请输入企业名称',
				industryId:0,	countryId:0,plateId:0, continentId:0,industryNumData:[],
				paramList:{continent:[],country:[],industry:[],plate:[]},countryData:[],
				//*页面公用*/
				enterinarr: [
					{curindex: 1,type: 9,name: "龙头企业库",tagnum:10010,}, 
					{curindex: 2,type: 2,name: "科创企业库",tagnum:10010,},
					], 
					tz_enterinarr:[
						{curindex: 1,type: 9,name: "上市公司",tagnum:10010,url:'markingEnterpriseist?type=9'},
						{curindex: 2,type: 1,name: "龙头企业",tagnum:10010,url:'markingEnterpriseist?type=1'},
						{curindex: 3,type: 0,name: "全部内资企业",tagnum:10010,url:'markingEnterpriseist?type=0'}, 
					],
				curindex: 5, 
				islogin: false,
				userdata:{},curWebsite:this.$api.getWebsiteType(),   
				onloadbtn:true,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,  
				maxPage: 10, //最大页数  
				enterpriseList: [],  
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序    
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',  
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				//外资企业筛选列表：注册资本 拿地数量 拿地面积 拿地金额 投资项目数量 投资项目金额 专利数量
				dimensionList:[ 
					{name:"注册资本",type:0},
					{name:'拿地数量',type:5 }, 
					{name:'拿地面积',type:6 },
					{name:'拿地金额',type:7 },
					{name:'投资项目数量',type:8 },
					{name:'投资项目金额',type:9 	},
					{name:'专利数量',type:11},
				 ],
				 isShowFreeUserTips: false,
				 mkcode:'A',
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},  
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation();
			if(this.userdata.zsdn_version == 1){
				this.mkcode = 'R';
			}else if(this.curWebsite.type == 5){
				this.mkcode = 'DB';
			}else{
				this.mkcode = 'A';
			}
			this.bus.$emit('loading', true);
			// this.provincedata =  dataInJs(); 
			// _this.notionlist=NotionTree; 
		 
		},
		mounted() {
		document.getElementById('app').style.background = "#f0f3f5"; 
  this.getForeignEnParamList();
		},
		methods: { 
			
		getIsFree(type,id){
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			if(type == 'contry'){
				this.countryId = id;
			}else if(type == 'industry'){
				this.industryId = id;
			}
			this.getForeignEnList();

		},
			//选择大洲 提出国家
			chooseOpport(data){ 
				if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
				this.countryData=data.country;
				// this.countryId= this.onloadbtn&& this.curWebsite.type == 4 ?301:0;
				this.continentId=data.id;
				this.getForeignEnList();
			},
			//获取境外上市企业国家、行业、板块参数列表
			getForeignEnParamList(){ 
				var ajaxurl=this.$api.cyl.foreignenterprise.paramList();
				var _this=this;
				this.getAxiosData(ajaxurl,this.userdata.token,function(res){
					console.log('国家、行业、板块的参数',res.data);
					_this.paramList=res.data;
					if(_this.curWebsite.type == 4 && _this.onloadbtn){ //{{curWebsite.keyword}}大脑初始化默认选中亚洲-中国
						console.log('abc',res.data.continent.length)
						for(var  i=0;i<res.data.continent.length;i++){ 
							if(res.data.continent[i].id == 30226){
								_this.chooseOpport(res.data.continent[i]);
							}
						}
						_this.onloadbtn=false; 
					}else{
						_this.getForeignEnList();
					}
					
				})
			}, 
			//获取境外上市企业列表
			getForeignEnList(pages,search){  
				this.page=pages?pages:1;
				this.bus.$emit('loading', true);
				var ajaxurl=this.getajaxUrl(this.$api.cyl.foreignenterprise.list(),search)+'&page='+this.page;
				var _this=this;
				// console.log(ajaxurl)
				this.getAxiosData(ajaxurl,this.userdata.token,function(res){
					console.log('境外上市企业',res); 
						_this.getIndustryNum(res.data.industry);
				// _this.paramList.industry=res.data.industry;
					_this.enterpriseList=res.list; 
					_this.getAxiosThen(res);
					// _this.bus.$emit('loading', false);
				})
			},
			//行业id数值和所有行业id交叉赋值
			getIndustryNum(datanum){
				let dataDefault=this.paramList.industry;
				for(var i=0;i<dataDefault.length;i++){
					for(var d=0;d<datanum.length;d++){
						if(datanum[d].industry == dataDefault[i].id){
							datanum[d].name=dataDefault[i].name;
							datanum[d].id=datanum[d].industry;
						}
					}
				}
				datanum=datanum.filter(list=>{
					return list.id != 228;
				})
				this.industryNumData=datanum;
			},
			pageHandler: function(page) { 
				this.getForeignEnList(page,'search'); 
			},
			//搜索关键词
			searchkwfun() {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					this.searchtext='';
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getForeignEnList(1,'search');
				// } 
			},
		 //公用部分
			getAxiosThen(data){
				var _this=this;
				_this.totalPage = data.totalPage;
				_this.pageSize = data.pageSize;
				_this.total = data.totalRecord;
				_this.haspage = data.list.length == data.pageSize; 
				_this.kwtextsearch = _this.searchtext != "";
				_this.kwtextsearchtext = _this.searchtext;
				_this.exportbtn = true;
				_this.confirmtext = "确认导出"; 
				// _this.enterpristlist=dataenterlist; 
				_this.bus.$emit('loading', false);
			},
			//企业列表导出数据
			getajaxUrl(apiurl,searchtype) {
				if(searchtype != 'search'){
					this.searchtext="";
				}   
				var kwaja =this.splicing('kw',this.searchtext); 
				// var countyidja =this.splicing('county',this.countyid);
				var industryIdja =this.splicing('industry',this.industryId);
				var plateIdja =this.splicing('plate',this.plateId); 
				// +'&continent='+this.continentId
				apiurl = apiurl + "?country="+this.countryId+'&industry='+this.industryId+'&continent='+this.continentId+'&plate='+this.plateId+kwaja; 
				return apiurl;
			},
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
				// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.forcapenterprise.export(),'search') + '&token=' + this.userdata.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					console.log('一分钟冷却计时')
				}, 60000)
			}, 
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getForeignEnList();
			}, 
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},  
		}
	}
</script>

<style>
</style>
